<template>
    <div>
        <my-header :activeMenu="'article-index'"></my-header>
        <div class="article_main">
            <div class="content">
                <div class="article_head">
                    <div class="title">{{detail.title}}</div>
                    <div class="time">{{detail.releaseDate}}</div>
                </div>
                <div class="article_html">
                    <div class="article_comments" @click="handleClick" v-html="detail.comments"></div>
                </div>
            </div>
        </div>
        <my-footer></my-footer>
        <div class="share_box">
            <img class="share_icon" src="@/assets/icon_share@2x.png"/>
            <span class="share_text">分享</span>
            <div class="qrcode_box">
                <!--<img id="qrcode" class="qrcode_img" src="@/assets/10yuan.png"/>-->
                <div id="qrcode" class="qrcode_img"></div>
                <p class="qrcode_p1">微信扫一扫</p>
                <p class="qrcode_p2">点击···后分享哟</p>
            </div>
        </div>
    </div>
</template>

<script>
    import MyHeader from "@/components/common/myHeader";
    import MyFooter from "@/components/common/myFooter";
    import getData from "@/api/getData";

    export default {
        name: "detail",
        components: {MyFooter, MyHeader},
        data() {
            return {
                id: '',
                detail: {}
            }
        },
        created() {
            let query = this.$route.query
            this.id = query.id || ''
            this.getDetail()
        },
        mounted(){
            var qrcode = new QRCode(document.getElementById("qrcode"), {
                text: "https://m.kuailework.com/kuailework_h5/news/news-detail?id=" + this.id,
                width: 115,
                height: 115,
                colorDark : "#000000",
                colorLight : "#ffffff",
                correctLevel : QRCode.CorrectLevel.H
            });
        },
        methods: {
            handleClick(event){
                if (event.target.tagName === 'IMG' && event.target.hasAttribute('data-href')) {
                    const dataHref = event.target.getAttribute('data-href');
                    window.location.href = dataHref;
                }
            },
            getDetail() {
                getData.get('https://nocoapi.kuailework.com/api/v2/tables/mr0ixhr2uoa6v9t/records/' + this.id, {}).then(res => {
                    console.log(res)
                    this.detail = res.data
                })
            }
        }
    }
</script>

<style scoped>
    .article_main {
        width: 100%;
        padding-top: 70px;
        padding-bottom: 80px;
        background: #F9FCFF;
    }

    .article_main .content {
        width: 1200px;
        margin: 0 auto;
        background-color: #fff;
        border-radius: 2px;
        overflow: hidden;
    }

    .article_main .content .article_head {
        padding-top: 50px;
        padding-bottom: 20px;
        margin: 0 30px;
        border-bottom: 1px solid rgba(181, 181, 181, .3);
    }

    .article_main .content .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 22px;
        color: #333333;
        line-height: 20px;
        text-align: center;
        font-style: normal;
    }

    .article_main .content .time {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 20px;
        text-align: center;
        font-style: normal;
        margin-top: 27px;
    }

    .article_main .content .article_html {
        margin: 20px 30px 50px;
    }
    .article_comments >>> img{
        max-width: 100%;
        /*display: block;*/
    }
    .article_comments >>> p{
        margin-top: 10px;
        /*text-indent: 2em;*/
        text-align: justify;
        font-size: 16px;
        line-height: 30px;
        color: #666;
    }
    .share_box{
        position: fixed;
        width: 66px;
        height: 77px;
        background: #FFFFFF;
        box-shadow: 0px 4px 12px 2px rgba(170,192,216,0.52);
        border-radius: 6px 0px 0px 6px;
        right: 0px;
        top: 45%;
        cursor: pointer;
    }
    .share_box .share_icon{
        display: block;
        width: 26px;
        height: 25px;
        margin: 20px auto 0;
    }
    .share_box .share_text{
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 13px;
        color: #333333;
        line-height: 18px;
        text-align: center;
        font-style: normal;
        margin-top: 6px;
    }
    .share_box .qrcode_box{
        position: absolute;
        right: 71px;
        top: 0px;
        width: 155px;
        height: 175px;
        background: #FFFFFF;
        box-shadow: 0px 0px 4px 0px #DCDCDC;
        border-radius: 6px;
        display: none;
    }
    .share_box .qrcode_box .qrcode_img{
        width: 115px;
        height: 115px;
        display: block;
        margin: 12px auto 5px;
    }
    .share_box .qrcode_box /deep/ img{
        width: 115px;
        height: 115px;
    }
    .share_box .qrcode_box p{
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 13px;
        color: #333333;
        line-height: 17px;
        text-align: center;
        font-style: normal;
    }
    .share_box:hover .qrcode_box{
        display: block;
    }
</style>